import { Variant, VariantProduct } from '__generated__/graphql';
import { BASKET_STOCK_STATUS } from 'utils/constants';
import { SimpleCart } from 'types/cart';

export const sendMixedCartErrorMessage = (
  cart: Partial<SimpleCart>,
  variation: Variant | VariantProduct
) => {
  const emptyCart = cart === null || cart?.productCount === 0;
  if (emptyCart) return;
  if (cart?.isMixedCartAllowed) return;

  const isPreSaleProduct =
    (variation?.displayOutOfStock?.presale &&
      cart?.basketInStockStatus !== BASKET_STOCK_STATUS.PREORDER) ||
    cart?.basketInStockStatus === BASKET_STOCK_STATUS.MIXED;

  const isNormalProduct =
    (!variation?.displayOutOfStock?.presale &&
      cart?.basketInStockStatus === BASKET_STOCK_STATUS.PREORDER) ||
    cart?.basketInStockStatus === BASKET_STOCK_STATUS.MIXED;

  return isPreSaleProduct || isNormalProduct;
};
